var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 0.976562L27.1781 12.1549C29.3889 14.3657 30.8944 17.1825 31.5044 20.249C32.1143 23.3155 31.8012 26.494 30.6047 29.3826C29.4082 32.2712 27.382 34.7401 24.7823 36.4771C22.1827 38.2141 19.1263 39.1413 15.9997 39.1413C12.8732 39.1413 9.81681 38.2141 7.21715 36.4771C4.6175 34.7401 2.5913 32.2712 1.39479 29.3826C0.198285 26.494 -0.114799 23.3155 0.495134 20.249C1.10507 17.1825 2.61062 14.3657 4.82141 12.1549L15.9997 0.976562ZM15.9997 29.9999C14.2316 29.9999 12.5359 29.2975 11.2857 28.0473C10.0355 26.797 9.33308 25.1013 9.33308 23.3332H5.99975C5.99975 25.9854 7.05332 28.5289 8.92868 30.4043C10.804 32.2797 13.3476 33.3332 15.9997 33.3332V29.9999Z",
    fill: "url(#paint0_linear_878_4541)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_878_4541",
    x1: 31.8081,
    y1: 39.1413,
    x2: -5.69037,
    y2: 8.07649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#277AF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27C6F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water-drop.5aa36d731942fa529dbf31fba8a241cc.svg";
export { ForwardRef as ReactComponent };